<template>
  <div>
    <TopBar title="Scanner" :cart="false"/>
    <div class="page-content">
      <div class="container">
        <div v-if="loading" class="dz-spinner color-spinner">
          <div class="spinner-border spinner-sm me-2 mb-2 text-primary" role="status">
          </div>
        </div>
        <Scanner v-if="!calling && !table" v-model="table"/>

        <div v-if="calling" class="">
          <div class="modal-body text-center small p-4">
            <div class="dz-spinner">
              <div class="spinner-grow text-warning spinner-lg me-2" role="status">
              </div>
            </div>
            <h5>Appel en cours</h5>
            <p class="m-b0">Une serveuse viendra juste après. Merci!</p>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref, watch} from "vue";
import TopBar from "@/views/master/layouts/partials/TopBar";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import Scanner from "@/components/scanner";
import { toast } from 'vue3-toastify';

const store = useStore()
const loading = ref(false)
const calling = ref(false)
const table = ref("")
const router = useRouter();

onMounted(() => {
})

watch(() => table.value, () => {
  if(table.value){
    callServer()
  }
})



function callServer () {
  calling.value = true
  store.dispatch('contact/callServer', {table_id: table.value.id})
      .then(response => {
        toast.success('Un(e) serveur(se) viendra dans quelques minutes')
      })
      .finally(() => {
        calling.value = false
        router.go(-1)
      })
}

</script>
<style scoped>
.cam-inside{
  position: absolute;
  top: 130%;
  width: 100%;
}
.sr-only{
  position: inherit;
}
.cam-border{
  margin-top: 30px;
  border: 3px solid var(--primary);
  border-radius: 10px;
  padding: 5px;
}
.dz-timeline.timeline-number .timeline-item .line-content-box{
  box-shadow: 0 0 0 0 transparent;
}

.dz-timeline.timeline-number .timeline-item .line-num{
  box-shadow: 0 0 0 0 transparent;
}

.input-radius textarea.form-control{
  border-radius: 10px;
}

</style>